var browntanwhiteswirlnervess = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/clay-wt/browntanwhiteswirlnervess.jpg';
var doubleflangevess = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/clay-wt/doubleflangevess.jpg';
var browntanwhiteswirlconnervess = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/clay-wt/browntanwhiteswirlconicalnervess.jpg';
var whitetoasthive = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/clay-wt/whitetoasthive.jpg';
var satellite = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/clay-wt/satellite.jpg';
var hive = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/clay-wt/hive.jpg';
var rustcreamclosedneckedvess = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/clay-wt/rustcreamclosedneckedvess.jpg';
var smtoastbrownnervess = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/clay-wt/smtoastbrownnervess.jpg';
var smtoastbrownnervessAlt = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/clay-wt/smtoastbrownnervess-alt.jpg';
var twocurvednervess = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/clay-wt/twocurvednervess.jpg';
var brownwhitetwisttop = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/clay-wt/brownwhitetwisttop.jpg';
var darkbrownwhiteswirlnervess = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/clay-wt/darkbrownwhiteswirlnervess.jpg';
var graywhitenerbowl = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/clay-wt/graywhitenerbowl.jpg';
var tallneckedvessflange = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/clay-wt/tallneckedvesselflange.jpg';
var bluewhiteswirlvess = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/clay-wt/bluewhiteswirlvess.jpg';
var openneckbluewhiteswirlvess = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/clay-wt/openneckbluewhiteswirlvess.jpg';
var bluewhiteswirlledgeneriagevessel = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/clay-wt/bluewhiteswirlledgeneriagevessel.jpg';
var bluewhiteswirloblongneriagevessel = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/clay-wt/bluewhiteswirloblongneriagevessel.jpg';
var toastbrownsquathive = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/clay-wt/toastbrownsquathive.jpg';
var toastwhiteswirltiltvessel = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/clay-wt/toastwhiteswirltiltvessel.jpg';
var zigzagneckedneriagevessel = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/clay-wt/zigzagneckedneriagevessel.jpg';
var bluecreamneriageflareneckvessel = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/clay-wt/bluecreamneriageflareneckvessel.jpg';
var creamochrebulbI = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/clay-wt/creamochrebulbI.jpg';
var bluecreamtwistedneckneriagevessel = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/clay-wt/bluecreamtwistedneckneriagevessel.jpg';
var browntoastneriagevessel = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/clay-wt/browntoastneriagevessel.jpg';
var browntoastneriageorb = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/clay-wt/browntoastneriageorb.jpg';

export const allImagesDesktopOrderClayWT = [
    [/*COLUMN 1*/
        [
            {
                name: bluecreamneriageflareneckvessel,
                artistName: "Lorraine Shemesh",
                title: "Blue & Cream Neriage Flare Neck Vessel",
                year: "2024",
                dimensions: "11 1/2 x 5 3/4 x 5 3/4 in., stoneware",
                link: "claywt22",
                privateCollection: ""
            }
        ],
        [
            {
                name: browntoastneriagevessel,
                artistName: "Lorraine Shemesh",
                title: "Brown & Toast Neriage Vessel",
                year: "2016",
                dimensions: "9 3/4 x 7 3/8 x 7 3/8 in., stoneware",
                link: "claywt23",
                privateCollection: ""
            }
        ],
        [
            {
                name: toastwhiteswirltiltvessel,
                artistName: "Lorraine Shemesh",
                title: "Toast & White Swirl Tilt Vessel",
                year: "2021",
                dimensions: "10 1/2 x 8 x 8 in., stoneware & porcelain",
                link: "claywt20",
                privateCollection: ""
            }
        ],
        [
            {
                name: bluewhiteswirloblongneriagevessel,
                artistName: "Lorraine Shemesh",
                title: "Blue & White Swirl Neriage Oblong Vessel",
                year: "2021",
                dimensions: "11 x 6 1/2 x 6 1/2 in., porcelain",
                link: "claywt18",
                privateCollection: ""
            }
        ],
        [
            {
                name: browntanwhiteswirlnervess,
                artistName: "Lorraine Shemesh",
                title: "Brown, Tan, & White, Swirl Neriage Vessel",
                year: "2017",
                dimensions: "7 1/2 x 8 1/4 x 8 1/4 in., porcelain",
                link: "claywt1",
                privateCollection: ""
            }
        ],
        [
            {
                name: doubleflangevess,
                artistName: "Lorraine Shemesh",
                title: "Double Flange Vessel",
                year: "2015",
                dimensions: "8 3/4 x 11 x 11 in., porcelain & stoneware",
                link: "claywt2",
                privateCollection: ""
            }
        ],
        [
            {
                name: browntanwhiteswirlconnervess,
                artistName: "Lorraine Shemesh",
                title: "Brown, Tan, & White, Swirl Conical Neriage Vessel",
                year: "2017",
                dimensions: "9 1/2 x 7 x 7 in., porcelain",
                link: "claywt3",
                privateCollection: "Private Collection"
            }
        ],
        [
            {
                name: whitetoasthive,
                artistName: "Lorraine Shemesh",
                title: "White & Toast Hive",
                year: "2016",
                dimensions: "7 1/2 x 6 x 6 in., stoneware & porcelain",
                link: "claywt4",
                privateCollection: ""
            }
        ]
    ],
    [/*COLUMN 2*/
        [
            {
                name: creamochrebulbI,
                artistName: "Lorraine Shemesh",
                title: "Cream & Toast Bulb I",
                year: "2024",
                dimensions: "10 1/2 x 6 x 6 in., stoneware",
                link: "claywt24",
                privateCollection: ""
            }
        ],
        [
            {
                name: browntoastneriageorb,
                artistName: "Lorraine Shemesh",
                title: "Brown & Toast Neriage Orb",
                year: "2016",
                dimensions: "8 3/8 x 5 1/4 x 5 1/4 in., stoneware",
                link: "claywt25",
                privateCollection: ""
            }
        ],
        [
            {
                name: bluewhiteswirlledgeneriagevessel,
                artistName: "Lorraine Shemesh",
                title: "Blue & White Swirl Ledge Neriage Vessel",
                year: "2021",
                dimensions: "7 1/2 x 8 1/4 x 8 1/2 in., porcelain",
                link: "claywt17",
                privateCollection: ""
            }
        ],
        [
            {
                name: zigzagneckedneriagevessel,
                artistName: "Lorraine Shemesh",
                title: "Zig-Zag Necked Neriage Vessel",
                year: "2021",
                dimensions: "14 x 5 3/4 x 5 3/4 in., stoneware",
                link: "claywt21",
                privateCollection: ""
            }
        ],
        [
            {
                name: rustcreamclosedneckedvess,
                artistName: "Lorraine Shemesh",
                title: "Rust & Cream Closed Necked Vessel",
                year: "2016",
                dimensions: "8 1/2 x 6 x 6 in., stoneware",
                link: "claywt7",
                privateCollection: ""
            }
        ],
        [
            {
                name: smtoastbrownnervess,
                artistName: "Lorraine Shemesh",
                title: "Small Toast & Brown Neriage Vessel",
                year: "2011",
                dimensions: "6 1/4 x 5 1/2 x 5 1/2 in., stoneware",
                link: "claywt8",
                privateCollection: ""
            },
            {
                name: smtoastbrownnervessAlt,
                artistName: "Lorraine Shemesh",
                title: "Small Toast & Brown Neriage Vessel",
                year: "2011",
                dimensions: "6 1/4 x 5 1/2 x 5 1/2 in., stoneware",
                link: "claywt9",
                privateCollection: ""
            }
        ],
        [
            {
                name: bluewhiteswirlvess,
                artistName: "Lorraine Shemesh",
                title: "Blue & White Swirl Vessel",
                year: "2015",
                dimensions: "6 3/4 x 5/1/2 x 5 1/2 in., porcelain",
                link: "claywt15",
                privateCollection: "Private Collection"
            }
        ],
        [
            {
                name: satellite,
                artistName: "Lorraine Shemesh",
                title: "Satellite",
                year: "2015",
                dimensions: "7 3/4 x 8 x 9 in., porcelain & stoneware",
                link: "claywt5",
                privateCollection: ""
            }
        ]
    ],
    [/*COLUMN 3*/
        [ 
            {
                name: bluecreamtwistedneckneriagevessel,
                artistName: "Lorraine Shemesh",
                title: "Blue & Cream Twisted Neck Neriage Vessel",
                year: "2024",
                dimensions: "15 x 5 1/2 x 5 1/2 in., stoneware",
                link: "claywt26",
                privateCollection: ""
            }
        ],
        [ 
            {
                name: hive,
                artistName: "Lorraine Shemesh",
                title: "Hive",
                year: "2015",
                dimensions: "10 x 7 x 7 in., stoneware",
                link: "claywt6",
                privateCollection: ""
            }
        ],
        [
            {
                name: toastbrownsquathive,
                artistName: "Lorraine Shemesh",
                title: "Toast & Brown Squat Hive",
                year: "2021",
                dimensions: "6 1/2 x 8 x 8 in., stoneware",
                link: "claywt19",
                privateCollection: "Private Collection"
            }
        ],
        [
            {    
                name: brownwhitetwisttop,
                artistName: "Lorraine Shemesh",
                title: "Brown & White Twist Top",
                year: "2011",
                dimensions: "7 1/2 x 7 x 7 in., porcelain",
                link: "claywt11",
                privateCollection: ""
            }
        ],
        [
            {
                name: darkbrownwhiteswirlnervess,
                artistName: "Lorraine Shemesh",
                title: "Dark Brown & White Swirl Neriage Vessel",
                year: "2011",
                dimensions: "7 3/4 x 5 x 5 1/4 in., porcelain",
                link: "claywt12",
                privateCollection: ""
            }
        ],
        [
            {
                name: graywhitenerbowl,
                artistName: "Lorraine Shemesh",
                title: "Gray & White Neriage Bowl",
                year: "1997",
                dimensions: "6 x 8 x 8 in., porcelain",
                link: "claywt13",
                privateCollection: ""
            }
        ],
        [
            {
                name: tallneckedvessflange,
                artistName: "Lorraine Shemesh",
                title: "Tall Necked Vessel with Flange",
                year: "1997",
                dimensions: "16 x 6 x 6 in., porcelain",
                link: "claywt14",
                privateCollection: ""
            }
        ],
        [
            {
                name: openneckbluewhiteswirlvess,
                artistName: "Lorraine Shemesh",
                title: "Open Necked Blue & White Swirl Vessel",
                year: "2016",
                dimensions: "6 1/2 x 8 x 8 in., porcelain",
                link: "claywt16",
                privateCollection: ""
            }
        ]
    ]          
]

export const allImagesMobileOrderClayWT = [
    [
    {
        name: bluecreamneriageflareneckvessel,
        artistName: "Lorraine Shemesh",
        title: "Blue & Cream Neriage Flare Neck Vessel",
        year: "2024",
        dimensions: "11 1/2 x 5 3/4 x 5 3/4 in., stoneware",
        link: "claywt22",
        privateCollection: ""
    },
    {
        name: browntoastneriagevessel,
        artistName: "Lorraine Shemesh",
        title: "Brown & Toast Neriage Vessel",
        year: "2016",
        dimensions: "9 3/4 x 7 3/8 x 7 3/8 in., stoneware",
        link: "claywt23",
        privateCollection: ""
    },
    {
        name: creamochrebulbI,
        artistName: "Lorraine Shemesh",
        title: "Cream & Toast Bulb I",
        year: "2024",
        dimensions: "10 1/2 x 6 x 6 in., stoneware",
        link: "claywt24",
        privateCollection: ""
    },
    {
        name: browntoastneriageorb,
        artistName: "Lorraine Shemesh",
        title: "Brown & Toast Neriage Orb",
        year: "2016",
        dimensions: "8 3/8 x 5 1/4 x 5 1/4 in., stoneware",
        link: "claywt25",
        privateCollection: ""
    },
    {
        name: bluecreamtwistedneckneriagevessel,
        artistName: "Lorraine Shemesh",
        title: "Blue & Cream Twisted Neck Neriage Vessel",
        year: "2024",
        dimensions: "15 x 5 1/2 x 5 1/2 in., stoneware",
        link: "claywt26",
        privateCollection: ""
    },
    {
        name: toastwhiteswirltiltvessel,
        artistName: "Lorraine Shemesh",
        title: "Toast & White Swirl Tilt Vessel",
        year: "2021",
        dimensions: "10 1/2 x 8 x 8 in., stoneware & porcelain",
        link: "claywt20",
        privateCollection: ""
    },
    {
        name: bluewhiteswirlledgeneriagevessel,
        artistName: "Lorraine Shemesh",
        title: "Blue & White Swirl Ledge Neriage Vessel",
        year: "2021",
        dimensions: "7 1/2 x 8 1/4 x 8 1/2 in., porcelain",
        link: "claywt17",
        privateCollection: ""
    },
    {
        name: zigzagneckedneriagevessel,
        artistName: "Lorraine Shemesh",
        title: "Zig-Zag Necked Neriage Vessel",
        year: "2021",
        dimensions: "14 x 5 3/4 x 5 3/4 in., stoneware",
        link: "claywt21",
        privateCollection: ""
    },
    {
        name: bluewhiteswirloblongneriagevessel,
        artistName: "Lorraine Shemesh",
        title: "Blue & White Swirl Neriage Oblong Vessel",
        year: "2021",
        dimensions: "11 x 6 1/2 x 6 1/2 in., porcelain",
        link: "claywt18",
        privateCollection: ""
    },
    {
        name: toastbrownsquathive,
        artistName: "Lorraine Shemesh",
        title: "Toast & Brown Squat Hive",
        year: "2021",
        dimensions: "6 1/2 x 8 x 8 in., stoneware",
        link: "claywt19",
        privateCollection: "Private Collection"
    },
    {
        name: browntanwhiteswirlnervess,
        artistName: "lorraineshemeshsiteimgsraine Shemesh",
        title: "Brown, Tan, & White, Swirl Neriage Vessel",
        year: "2017",
        dimensions: "7 1/2 x 8 1/4 x 8 1/4 in., porcelain",
        link: "claywt1",
        privateCollection: ""
    },
    {
        name: doubleflangevess,
        artistName: "Lorraine Shemesh",
        title: "Double Flange Vessel",
        year: "2015",
        dimensions: "8 3/4 x 11 x 11 in., porcelain & stoneware",
        link: "claywt2",
        privateCollection: ""
    },
    {
        name: browntanwhiteswirlconnervess,
        artistName: "Lorraine Shemesh",
        title: "Brown, Tan, & White, Swirl Conical Neriage Vessel",
        year: "2017",
        dimensions: "9 1/2 x 7 x 7 in., porcelain",
        link: "claywt3",
        privateCollection: "Private Collection"
    },
    {
        name: whitetoasthive,
        artistName: "Lorraine Shemesh",
        title: "White & Toast Hive",
        year: "2016",
        dimensions: "7 1/2 x 6 x 6 in., stoneware & porcelain",
        link: "claywt4",
        privateCollection: ""
    },
    {
        name: satellite,
        artistName: "Lorraine Shemesh",
        title: "Satellite",
        year: "2015",
        dimensions: "7 3/4 x 8 x 9 in., porcelain & stoneware",
        link: "claywt5",
        privateCollection: ""
    },
    {
        name: hive,
        artistName: "Lorraine Shemesh",
        title: "Hive",
        year: "2015",
        dimensions: "10 x 7 x 7 in., stoneware",
        link: "claywt6",
        privateCollection: ""
    },
    {
        name: rustcreamclosedneckedvess,
        artistName: "Lorraine Shemesh",
        title: "Rust & Cream Closed Necked Vessel",
        year: "2016",
        dimensions: "8 1/2 x 6 x 6 in., stoneware",
        link: "claywt7",
        privateCollection: ""
    },
    {
        name: smtoastbrownnervess,
        artistName: "Lorraine Shemesh",
        title: "Small Toast & Brown Neriage Vessel",
        year: "2011",
        dimensions: "6 1/4 x 5 1/2 x 5 1/2 in., stoneware",
        link: "claywt8",
        privateCollection: ""
    },
    {
        name: smtoastbrownnervessAlt,
        artistName: "Lorraine Shemesh",
        title: "Small Toast & Brown Neriage Vessel",
        year: "2011",
        dimensions: "6 1/4 x 5 1/2 x 5 1/2 in., stoneware",
        link: "claywt9",
        privateCollection: ""
    },
    {
        name: bluewhiteswirlvess,
        artistName: "Lorraine Shemesh",
        title: "Blue & White Swirl Vessel",
        year: "2015",
        dimensions: "6 3/4 x 5/1/2 x 5 1/2 in., porcelain",
        link: "claywt15",
        privateCollection: "Private Collection"
    },
    {    
        name: brownwhitetwisttop,
        artistName: "Lorraine Shemesh",
        title: "Brown & White Twist Top",
        year: "2011",
        dimensions: "7 1/2 x 7 x 7 in., porcelain",
        link: "claywt11",
        privateCollection: ""
    },
    {
        name: darkbrownwhiteswirlnervess,
        artistName: "Lorraine Shemesh",
        title: "Dark Brown & White Swirl Neriage Vessel",
        year: "2011",
        dimensions: "7 3/4 x 5 x 5 1/4 in., porcelain",
        link: "claywt12",
        privateCollection: ""
    },
    {
        name: graywhitenerbowl,
        artistName: "Lorraine Shemesh",
        title: "Gray & White Neriage Bowl",
        year: "1997",
        dimensions: "6 x 8 x 8 in., porcelain",
        link: "claywt13",
        privateCollection: ""
    },
    {
        name: tallneckedvessflange,
        artistName: "Lorraine Shemesh",
        title: "Tall Necked Vessel with Flange",
        year: "1997",
        dimensions: "16 x 6 x 6 in., porcelain",
        link: "claywt14",
        privateCollection: ""
    },
    {
        name: openneckbluewhiteswirlvess,
        artistName: "Lorraine Shemesh",
        title: "Open Necked Blue & White Swirl Vessel",
        year: "2016",
        dimensions: "6 1/2 x 8 x 8 in., porcelain",
        link: "claywt16",
        privateCollection: ""
    }]      
]
